import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const githubCachesPlugin = createPlugin({
  id: 'github-caches',
  routes: {
    root: rootRouteRef,
  },
});

export const GithubCachesPage = githubCachesPlugin.provide(
  createRoutableExtension({
    name: 'GithubCachesPage',
    component: () =>
      import('./components/GithubCachesPage').then(m => m.GithubCachesPage),
    mountPoint: rootRouteRef,
  }),
);
